import { render, staticRenderFns } from "./customFees.vue?vue&type=template&id=39b66ac0&scoped=true"
import script from "./customFees.vue?vue&type=script&lang=js"
export * from "./customFees.vue?vue&type=script&lang=js"
import style0 from "./customFees.vue?vue&type=style&index=0&id=39b66ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b66ac0",
  null
  
)

export default component.exports